import { ConnectivityViewModel } from "../viewmodels/ConnectivityViewModel.js";
import { Icon, Toast, toastManager } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useEvent, useSingleton } from "mvc-kit/react";
import { HiMiniSignalSlash } from "react-icons/hi2";
// src/modules/AppWrapper2/components/OfflineToast.tsx
/**
* Renders the offline toast in the component layer (the ViewModel only emits).
* Kept as its own leaf component so subscribing to connectivity state doesn't
* re-render the whole app shell on every network toggle.
*/
function OfflineToast() {
	const connectivityVM = useSingleton(ConnectivityViewModel);
	useEvent(connectivityVM, "wentOffline", () => {
		toastManager(/* @__PURE__ */ jsxs(Toast, {
			icon: /* @__PURE__ */ jsx(Icon, {
				color: "critical",
				Icon: HiMiniSignalSlash
			}),
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-critical font-bold",
				children: "Device Offline"
			}), /* @__PURE__ */ jsx("div", {
				className: "text-color-critical-light text-sm font-light",
				children: "Check your network connection"
			})]
		}), {
			autoClose: false,
			position: toastManager.POSITION.TOP_CENTER,
			toastId: "network-online-toast",
			variant: "critical"
		});
	});
	useEvent(connectivityVM, "wentOnline", () => {
		toastManager.dismiss("network-online-toast");
	});
	return null;
}
export { OfflineToast };

//# sourceMappingURL=OfflineToast.js.map